module.exports = __webpack_public_path__ + "static/lebc-poster-55da5695578feca4dc72c875ff4cfffc.png";